var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 188,
    viewBox: "0 0 226 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3023_39652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.254 43.7692L61.9341 81.1875L86.9791 100.06L115.299 62.6419L90.254 43.7692Z",
    fill: "#BA7121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.374 57.0671L79.0479 94.4805L86.7571 100.292L115.084 62.8786L107.374 57.0671Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8782 48.2154L83.5054 52.6719L108.55 71.5445L111.923 67.088L86.8782 48.2154Z",
    fill: "#52ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1139 71.7043L65.7402 76.1602L90.7819 95.0372L94.1556 90.5813L69.1139 71.7043Z",
    fill: "#FF892A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.167 64.2827C116.94 65.9008 114.631 66.2266 113.01 65.0018L88.596 46.6077C86.9744 45.383 86.6478 43.0795 87.8753 41.4614C89.1027 39.8434 91.4112 39.5175 93.0328 40.7423L117.447 59.1476C119.068 60.3724 119.384 62.6759 118.167 64.2939V64.2827Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.447 59.1473L117.356 59.0799C117.255 59.6305 117.052 60.1586 116.692 60.6305C115.465 62.2486 113.156 62.5744 111.534 61.3496L87.2106 43.0117C86.9742 44.3264 87.4471 45.7309 88.5958 46.5962L113.01 64.9903C114.631 66.215 116.94 65.8892 118.167 64.2711C119.395 62.6531 119.068 60.3496 117.447 59.1248V59.1473Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5869 102.037C88.3594 103.655 86.0509 103.969 84.4293 102.756L60.0154 84.3616C58.3938 83.1369 58.0673 80.8334 59.2947 79.2153C60.5222 77.5973 62.8307 77.2714 64.4523 78.4962L88.8662 96.9015C90.4878 98.1263 90.8143 100.43 89.5869 102.048V102.037Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1479 97.1488C89.0578 97.7331 88.8438 98.3062 88.4609 98.8006C87.2447 100.419 84.9362 100.745 83.3034 99.5197L58.9007 81.1256C58.7994 81.047 58.7205 80.9571 58.6305 80.8672C58.4278 82.1594 58.912 83.5078 60.0381 84.3505L84.452 102.745C86.0736 103.969 88.3821 103.644 89.6096 102.025C90.7582 100.509 90.533 98.4073 89.1704 97.1376L89.1479 97.1488Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.819 134.05C186.15 136.601 186.263 141.005 184.214 143.713C182.164 146.421 177.885 147.511 174.788 145.972C136.658 125.69 135.735 107.116 97.605 86.8344C94.5082 85.295 94.6884 80.497 96.7379 77.789C98.7874 75.081 103.359 73.5978 105.702 76.1373C135.679 107.195 153.831 102.992 183.819 134.05Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.754 135.387C184.518 136.32 184.124 137.208 183.561 137.949C181.511 140.657 177.232 141.747 174.146 140.208C136.016 119.926 135.093 101.352 96.9519 81.0704C96.4114 80.8007 95.9722 80.4299 95.6231 79.9805C94.801 82.5761 95.2402 85.6436 97.605 86.8235C135.735 107.105 136.658 125.679 174.788 145.961C177.885 147.5 182.164 146.41 184.214 143.702C185.937 141.421 186.128 137.949 184.754 135.387Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.546 90.7565C122.469 89.543 124.192 89.307 125.408 90.2172C126.625 91.1386 126.861 92.8578 125.949 94.0713L120.431 101.353C119.508 102.566 117.785 102.802 116.568 101.892C115.352 100.97 115.116 99.2513 116.028 98.0378L121.535 90.7565H121.546Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.219 91.2266L117.762 102.407C118.753 102.575 119.789 102.216 120.442 101.362L125.96 94.0806C126.602 93.2267 126.67 92.1255 126.231 91.2266H126.219Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.514 121.934H47.9727V138.676H109.514V121.934Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.487 142.304C117.487 145.236 115.111 147.607 112.172 147.607H45.3152C42.3761 147.607 40 145.236 40 142.304C40 139.371 42.3761 137 45.3152 137H112.172C115.111 137 117.487 139.371 117.487 142.304Z",
    fill: "#9B622F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3023_39652",
    x: 0,
    y: 0,
    width: 225.665,
    height: 187.605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.79 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3023_39652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3023_39652",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel);
export default __webpack_public_path__ + "static/media/gavel.194247053de9695f4d496d00a2935a56.svg";
export { ForwardRef as ReactComponent };